import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=3712a821&scoped=true"
import script from "./Allocation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Allocation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=3712a821&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712a821",
  null
  
)

export default component.exports